import { actionTypes as downloadMeasurementsActionTypes } from './../../../../Header/DownloadMeasurements/constants';

export const setMeasurementDialogParams = (measurementDownloadDialogParams) => {
    return (dispatch) => {
        dispatch({ type: downloadMeasurementsActionTypes.SET_MEASUREMENT_DIALOG_PARAMS, measurementDownloadDialogParams });
    };
};
